<h3 mat-dialog-title class="title-layout">Edit Variant</h3>
<div mat-dialog-content>

  <p style="font-size: 16px;" [style.color]="variantStatus == 'inactive' ? 'red' : 'black' ">
    Variant Status: {{variantStatus | uppercase}}<br> 
    {{variantMsg}}
  </p>
  

  <form [formGroup]="fg_RenameVariant" >
    <mat-form-field class="card-dialog">
      <mat-label>Rename Variant</mat-label>
        <input matInput #renameInput id="variantname" type="text" formControlName="f_VariantName" cdkTextareaAutosize>
    </mat-form-field>
    
    <!--<p>Models used in the variant:</p>
    <mat-list role="list" class="model-list" *ngFor="let model of model_variants">
      <mat-list-item role="listitem"><span style="color: blue; opacity: 0.7">{{model.model_name}}</span></mat-list-item>
    </mat-list>-->

    <p>Models used in the variant:</p>
    <div class="dynamic-column-container">
    <mat-list>
    <mat-list-item *ngFor="let model of model_variants" class="model-item">
      <div matListItemTitle class="truncate" [matTooltip]="model.model_name" matTooltipPosition="above" [matTooltipShowDelay]="300">
        <span style="color: blue; opacity: 0.7">{{ model.model_name }}</span></div>
    </mat-list-item>
  </mat-list>
</div>

  </form>
</div>

<div mat-dialog-actions>
  <button  mat-button color="primary" (click)="onSubmit()">Submit</button>
  <button mat-button color="primary" (click)="onAssignNonActive()">Edit Variant Status</button>
  <button mat-button color="warn" (click)="onReset()">Reset Name</button>
  <button mat-button (click)="onNoClick()">Cancel</button>
</div>

<div *ngIf="isBusy">
    <mat-spinner></mat-spinner>
</div>
